"use client";

import type { DehydratedState } from "@tanstack/react-query";
import { HydrationBoundary } from "@tanstack/react-query";
import { type ReactNode } from "react";

export interface ComboHydratorProps {
  children: ReactNode;
  dehydratedState: DehydratedState;
}

export const ComboHydrator = ({
  children,
  dehydratedState,
}: ComboHydratorProps) => (
  <HydrationBoundary state={dehydratedState}>{children}</HydrationBoundary>
);
